module.exports = new __parcel__URL__("logo.a2202ba2.png").toString();